import React, { useState } from "react"
import {
  MainContainer,
  Heading,
  SponsorImage,
  InnerContainer,
} from "./sponsorstyles"
import google from "../../images/google.png"
import evanto from "../../images/evanto.png"
import linkdin from "../../images/linkdin.png"
import dribble from "../../images/dribble.png"
import mailchimp from "../../images/mailchimp.png"
import pinterest from "../../images/pinterest.png"
import spotify from "../../images/spotify.png"
import vimeo from "../../images/vimeo.png"

const Sponsors = ({ sponsor }) => {
  const sponsorsarray = [google, evanto, linkdin, dribble]
  const partnersarray = [mailchimp, pinterest, spotify, vimeo]
  const mainarray = sponsor ? sponsorsarray : partnersarray
  return (
    <MainContainer>
      <Heading>{sponsor ? "Sponsors" : "Partners"}</Heading>
      <InnerContainer>
        {mainarray.map(node => (
          <SponsorImage image={node} />
        ))}
      </InnerContainer>
    </MainContainer>
  )
}

export default Sponsors
